
import React, { useState, ReactNode, cloneElement } from "react";
import {Box,
        Avatar,
        Typography} from "@mui/material";
import {useTheme, alpha} from '@mui/material/styles';
import MonitorIcon from '@mui/icons-material/Monitor';
import {ObjectModel} from '../../models/models';
import {CustomIconComponent} from "./CustomIcon";


/*DEFINITION FOR IMAGE ICONS */

type ObjectAvatarProps = {
  objectMetadata: ObjectModel,
  size?: number;
}

export const ObjectAvatar = (
  {
    objectMetadata,
    size=40
  }: ObjectAvatarProps) => {

    const renderIcon = () => {
      if(objectMetadata.ReferencedIcon_sys){
        return (
          <CustomIconComponent
          icon={objectMetadata.ReferencedIcon_sys}
          />
        )
      }
      return <MonitorIcon />
    }

    return (
      <Box sx={{display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 1,
                mt: 1}}
      >
        <Avatar
          sx={{
            color: objectMetadata.HexColour_sys,
            backgroundColor: alpha(objectMetadata.HexColour_sys,0.12),
            width: size,
            height: size
          }}
        >
          {renderIcon()}
        </Avatar>
        <Typography
          variant="subtitle2"
          sx={{fontWeight: 700,
               color: objectMetadata.HexColour_sys}}
        >
          {objectMetadata.Label_sys}
        </Typography>
      </Box>
    )
  }


  /******************************/
